<template>
  <div>
    <SideNavbar
      class=" h-screen overflow-hidden Slidesidebar"
      v-if="window.width <= 768 && ShowSlidesidebar"
      v-click-outside="closeSlideSidebar"
    />
    <div class="grid grid-cols-5 h-screen overflow-hidden main-template">
      <SideNavbar v-show="isShowsidebar" />

      <div
        class="h-screen overflow-scroll"
        v-bind:class="[Showsidebar ? 'col-span-4' : 'col-span-5']"
      >
        <span class="flex"
          ><img
            class="ml-5 pointer"
            @click="ToggleSidebar()"
            src="@/assets/images/elements/hammer.svg"
            v-show="!Showsidebar"
          />
          <Header class="w-full" />
        </span>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/elements/Header.vue";
import SideNavbar from "@/views/elements/SideNavbar.vue";
import themeConfig from "../../themeConfig";

export default {
  components: {
    Header,
    SideNavbar
  },
  data() {
    return {
      routerTransition: themeConfig.routerTransition || "none",
      window: {
        width: 0,
        height: 0
      },
      Showsidebar: false,
      ShowSlidesidebar: false
    };
  },
  methods: {
    ToggleSidebar() {
      this.ShowSlidesidebar = true;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    closeSlideSidebar() {
      this.ShowSlidesidebar = false;
    }
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  computed: {
    isShowsidebar() {
      return this.window.width <= 768
        ? (this.Showsidebar = false)
        : (this.Showsidebar = true);
    },
    isShowSlidesidebar() {
      return this.window.width <= 768
        ? (this.ShowSildesidebar = false)
        : (this.ShowSildesidebar = true);
    }
  }
};
</script>

<style lang="scss" scoped>
.main-template {
  background-image: url("../../src/assets/images/bg/AdminBG.png");
  background-size: cover;
}

.Slidesidebar {
  position: absolute;
  width: 40% !important;
  z-index: 999;
  background-color: rgb(248, 253, 255);
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
}
</style>
